/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Actions/Content/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let profilePatientSubmitData = fromData.useDataSubmit({ viewPath,
context: 'profile_patient',
})
let profilePatientIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'profile_patient',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceXs}
 type="primary"
 data="profile_patient"
 onClick={profilePatientSubmitData}
 disabled={profilePatientIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}